import { Box, useBreakpointValue } from '@chakra-ui/react';
import { NavBar } from './NavBar';
import { Outlet } from 'react-router-dom';
import { useSystemSettingQuery } from 'src/features/systemSettings/api/useSystemSettingQuery';
import { DisableObt } from 'src/features/systemSettings/components/DisableObt';
import { DisableObtKey } from 'src/constants/systemSettingKeys';

export const MainLayout = () => {
  const disableObt = useSystemSettingQuery(DisableObtKey);
  const showDesktopView = useBreakpointValue({ base: false, sm: false, md: true, lg: true, xlTo2xl: true });
  return (
    <Box backgroundColor={'#F3F4F7'} minHeight={'100vh'}>
      <NavBar />
      <Box
        id='mainLayoutContainer'
        width={'100%'}
        height='100vh'
        overflowY='auto'
        paddingTop={showDesktopView ? '80px' : '55px'}>
        {disableObt.data && disableObt.data.BoolValue ? (
          <DisableObt obtDisabledMessage={disableObt.data.SettingMessage} />
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  );
};
